import { FicheContainer, useFiche } from '@mairistem/fiche';
import React from 'react';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';

import { baseUrl, baseUrlFront } from '@/routes';
import type { ErrorFieldType, PayeurType } from '@/types';
import { validatePayeur } from '@/utils';
import {
  annulerRetourComptant,
  doitRetournerAuComptant,
  memoriserPayeurCree,
} from '@/utils/comptantHandoff';
import { ErrorToastContent } from '../Autre';
import { LoadingContextProvider } from '../Context';
import PayeurFiche from './Fiche/PayeurFiche';
import PayeurFicheBar from './Fiche/PayeurFicheBar';

const FeaturePayeurFiche = () => {
  const [service] = useFiche(`${baseUrl}/payeurs`);
  const history = useHistory();

  const handleValidate = React.useCallback(
    (data: any): ErrorFieldType[] => validatePayeur(data),
    [],
  );

  // Retour à l'encaissement au comptant après création d'un payeur depuis ce flux.
  // On force aussi le mode "édition" (bouton enregistrer/annuler) car on arrive
  // directement par URL sur une fiche neuve : le framework ne bascule en création
  // qu'au clic sur "+" ou à la 1re modification, sinon il affiche "+"/"supprimer".
  const buildHandlers = React.useCallback(
    (p: any) => ({
      mode: doitRetournerAuComptant() ? 'edit' : undefined,
      onSaved: (data: PayeurType, status?: { created?: boolean }) => {
        p.onSaved?.(data, status);
        if (status?.created && doitRetournerAuComptant()) {
          memoriserPayeurCree(data);
          history.push(`${baseUrlFront}/encaissement`);
        }
      },
      onCanceled: (...args: any[]) => {
        p.onCanceled?.(...args);
        annulerRetourComptant();
      },
    }),
    [history],
  );

  const handleApiError = React.useCallback((d) => {
    const message = d?.message?.message || "L'enregistrement du payeur a echoué";

    toast(<ErrorToastContent description={message} />, {
      type: 'error',
      style: { width: 350, float: 'right' },
    });
  }, []);

  return (
    <LoadingContextProvider>
      <FicheContainer
        service={service}
        type="payeur"
        onValidate={handleValidate}
        onApiError={handleApiError}
      >
        {(p) => (
          <>
            <PayeurFicheBar {...p} {...buildHandlers(p)} />
            <PayeurFiche {...p} />
          </>
        )}
      </FicheContainer>
    </LoadingContextProvider>
  );
};

export default FeaturePayeurFiche;
